export const updateCaptionsArray = (currentCaptions, newCaption) => {
    const updatedCaptions = [...currentCaptions];
    const { name, streamId, caption, isFinal } = newCaption;
    // Find the last index of a caption with the same streamId
    let captionIndex = -1;
    for (let i = updatedCaptions.length - 1; i >= 0; i--) {
        if (updatedCaptions[i]?.streamId === streamId) {
            captionIndex = i;
            break;
        }
    }
    const previousCaptionIndex = updatedCaptions.length - 1;
    // Determine if this caption is from the same speaker as the previous one
    const isFromSameSpeakerAsPrevious = previousCaptionIndex >= 0 &&
        updatedCaptions[previousCaptionIndex]?.streamId === streamId;
    if (captionIndex === -1) {
        // No existing caption for this user, create a new one
        updatedCaptions.push({
            name,
            streamId,
            caption,
            isFinal,
            showName: true,
        });
    }
    else {
        const existingCaption = updatedCaptions[captionIndex];
        if (isFinal) {
            // This indicates the end of this caption
            existingCaption.caption = caption;
            existingCaption.isFinal = true;
        }
        else if (existingCaption.isFinal) {
            // If the previous caption was final create a new caption (start of new caption)
            updatedCaptions.push({
                name,
                streamId,
                caption,
                isFinal: false,
                showName: !isFromSameSpeakerAsPrevious,
            });
        }
        else {
            // Else, just update the latest non-final caption
            existingCaption.caption = caption;
        }
    }
    return updatedCaptions;
};
